import { useEffect, useState } from "react";
import { Container, Table } from "../../../components";
import { dataTable, getBarrios } from "./handlers";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserWrapper";
import { useContext } from "react";

export default function Barrios() {
  const { actions: ua } = useContext(UserContext);
  const nav = useNavigate();
  const [barrios, setBarrios] = useState({
    data: [],
    error: null,
    loading: false,
  });

  useEffect(() => {
    if (ua.hasRole("admin.app")) {
      getBarrios(barrios, setBarrios);
    } else {
      nav("/");
    }
  }, []);

  return (
    <Container linkBack={"/admin"} titulo={"Listado de Barrios"}>
      {/* {barrios.loading && (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )} */}
      {barrios.data && (
        <div>
          <Table
            data={dataTable(barrios.data)}
            loading={barrios.loading}
            search={true}
            render={() => {
              return (
                <Link
                  className="btn btn-sm btn-primary mt-2 mb-2 mx-2 d-flex align-items-center"
                  type="button"
                  to={"/crear_barrio"}
                >
                  Crear Barrio
                </Link>
              );
            }}
          />
        </div>
      )}
      {barrios.error && "Hay error"}
    </Container>
  );
}
